<div class="d-md-flex d-sm-block">
  <form class="d-flex flex-grow-1 justify-content-between gap-3" [formGroup]="formGroup">
    <div class="d-md-flex d-sm-block flex-grow-1 gap-3">
      <input type="text" formControlName="title" class="form-control" placeholder="Search...">
    </div>
    <div class="d-md-flex justify-content-end gap-3">
      <button type="submit" name="searchBtn" class="btn btn-outline-primary" (click)="onFilterFormSubmit()" >
        Търси
      </button>
    </div>
  </form>
</div>
